import React from 'react'
import ContentLoader from 'react-content-loader'
import get from 'lodash/get'

import colors from 'colors'

const AvailabilityHoursLoader = () => {
  return (
    <>
      <ContentLoader
        speed={2}
        viewBox="0 0 450 300"
        backgroundColor={`${get(colors, 'cream.dark', '#F4F4F5')}`}
        foregroundColor={`${get(colors, 'grey.lighter', '#e8e8e8')}`}
      >
        {/* Header text */}
        <rect x="25" y="30" rx="2" ry="2" width="350" height="13" />

        {/* Time zone label */}
        <rect x="25" y="70" rx="2" ry="2" width="80" height="13" />
        {/* Time zone value */}
        <rect x="25" y="95" rx="2" ry="2" width="280" height="13" />

        {/* Set your default meeting link label */}
        <rect x="25" y="140" rx="2" ry="2" width="180" height="13" />
        {/* Input field placeholder */}
        <rect x="25" y="170" rx="4" ry="4" width="400" height="40" />

        {/* Buttons */}
        <rect x="250" y="240" rx="20" ry="20" width="80" height="36" />
        <rect x="345" y="240" rx="20" ry="20" width="80" height="36" />
      </ContentLoader>
    </>
  )
}

export default AvailabilityHoursLoader
